import React from 'react';
import NameField from "./NameField";
import PhoneField from "./PhoneField";
import FormField from "./FormField";

const ParentField = ({entity, required}) => {
  return (
    <React.Fragment>
      <NameField entity={entity} required={required} />
      <PhoneField label="Primary Phone Number" entity={entity} name="phone_1" required={required} />
      <PhoneField label="Secondary Phone Number" entity={entity} name="phone_2"/>

      <div className="row">
        <FormField label="Email" type="text" name={`${entity}.email`} colWidth={6} required={required} />
      </div>

      <div className="row">
        <FormField label="Employer" type="text" name={`${entity}.employer`} colWidth={6} required={required} />
        <FormField label="Job Title" type="text" name={`${entity}.job_title`} colWidth={6} required={required} />
      </div>
    </React.Fragment>
  );
};

export default ParentField;
